<template>
  <div class="dolu">
    <exams-workflow v-if="subject.s_type > 0"></exams-workflow>
  </div>
</template>
<script>
  import ExamsWorkflow from 'src/components/Views/ExamsWorkflow.vue';
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  export default {
    components: {
      [ExamsWorkflow.name]: ExamsWorkflow,
    },

    computed: {
      ...mapState({
        id_examination: state => state.id_examination,
        user: state => state.user,
        subject: state => state.subject,
        token: state => state.token,
      }),

    },

    data () {
      return {

      }
    },

    methods: {
      handleShowQC (index, row, event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        // this.m_id_project_detail(row.id_project);

        this.a_show_qc( { "id_project": row.id_project } );
        // this.files = [];
        // this.other_files = [];
        // this.csv_file = [];
        // this.m_modal_project_stat(true);
      },


      ...mapMutations({
        m_id_project: 'm_id_project',
        m_id_project_detail: 'm_id_project_detail',
        m_id_examination: 'm_id_examination',
        m_id_var: 'm_id_var',
        m_np_id_workflow: 'm_np_id_workflow',
        m_modal_new_project: 'm_modal_new_project',
        m_modal_project_detail: 'm_modal_project_detail',
        m_modal_project_stat: 'm_modal_project_stat',
      }),


      ...mapActions({
        a_projects: 'a_projects',
        a_examinations: 'a_examinations',
        a_workflows: 'a_workflows',
        a_new_project: 'a_new_project',
        a_project_update: 'a_project_update',
        a_show_qc: 'a_show_qc',

        }),

    },

    beforeMount () {

    },

  }
</script>
<style scoped lang="scss">
.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table {
  font-size: 12px !important;
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}



.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

h4 {
  margin-top: 5px !important;
}

.dolu {
  padding-top: 80px !important;
}

.table > thead > tr > th, .el-table table > thead > tr > th {
  font-size: 12px !important;
}

.mezera {
  margin-right: 10px;
}
</style>
